// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Application/types/WoodConnection/styles.scss
// module id = 1240
// module chunks = 0